module.exports = __webpack_public_path__ + "static/media/oval.0ae4a190.svg";